import { postData } from './http';

export function getSeatPlan(request) {
    return postData('/api2/flights/seatplan/getseatplan', request, { logErrors: false })
        .then(addMinCostPerPerson);
}

export function addMinCostPerPerson(seatPlan) {
    const segments = seatPlan.Segments;
    const outbound = segments && segments.Outbound || [];
    const inbound = segments && segments.Inbound || [];
    const flights = [].concat(outbound, inbound);
    seatPlan.minCostPerPerson = _.sumBy(flights, getMinSeatPriceFromflight);
    return seatPlan;
}

function getMinSeatPriceFromflight(flight) {
    let seats = [];
    flight.SeatPlan.Rows.forEach(row => {
        row.Blocks.forEach(block => {
            seats = seats.concat(block.Seats);
        });
    });
    const minSeat = _.minBy(_.filter(seats, { IsAvailable: true }), seat => seat.AdultPrice);
    return minSeat.AdultPrice;
}
